import { render, staticRenderFns } from "./QuickMenu.vue?vue&type=template&id=0cfab770&scoped=true&"
import script from "./QuickMenu.vue?vue&type=script&lang=js&"
export * from "./QuickMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfab770",
  null
  
)

export default component.exports